// extracted by mini-css-extract-plugin
export default {"container":"IFSearchFieldSkeleton_container__h6+qO"};